import model from '../mixins/model';

export default {
    mixins: [model],
    form: true,
    model() {
        return {
            categories: []
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            this.dispatch((resolve, reject) => {

                this.$http.request({ url: 'category.json', name: "cms" })
                    .then((response) => {
                        this.model.categories = response.data.terms;
                    })
                    .catch(reject);

            });


        },
    }
}